import {
    Checkbox,
    Typography,
    TextField,
    makeStyles,
    FormControlLabel,
  } from "@material-ui/core";
  import { Autocomplete } from "@material-ui/lab";
  import { classes as workerStyles } from "../AddWorkerStyles";
  import React, { useEffect, useState } from "react";
  import { getLocationForCountry } from "services/bulkUpload";
  import { Controller, useFormContext } from "react-hook-form";
  import { isEmptyObject } from "utils";
  import { useTranslation } from "react-i18next";
  import { properCase } from "utils";
  const useStyles = makeStyles((theme) => workerStyles(theme));
  
  const SBSUserAccess = ({
    selectedWorker,
    manager,
    initialValue,
    setSbsValid,
    setIsSbsWorker,
    setSbsDistBuilingMap,
    sbsDistBuilingMap,
  }) => {
   
  const classes = useStyles();
  const { control, setValue, getValues, errors, clearErrors } = useFormContext();
  const [districts, setDistricts] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [isActiveTicked, setIsActiveTicked] = useState(false);
  const [sbsDistrict, setSbsDistrict] = useState([]);
  const [sbsBuilding, setSbsBuilding] = useState([]);
  const [sbsRole, setSbsRole] = useState(null);
  const { t, i18n } = useTranslation();
  
  useEffect(() => {
    if (!isEmptyObject(initialValue) && districts.length>0) {
      setValue("isSbsActive", initialValue.isActive);
     // setValue("sbsDistrict", initialValue.sbsDistricts);
      if(initialValue.sbsDistricts && initialValue.sbsDistricts.length>0){
        let districtData=[];
        districts.forEach((record)=>{
            if(initialValue.sbsDistricts.includes(record.district)){
              districtData.push(record);
            }
        });
        setValue('sbsDistrict', districtData);
      } 
      if(initialValue.sbsBuildings && initialValue.sbsBuildings.length>0){
        setValue("sbsBuilding", initialValue.sbsBuildings.map((item) => item.buildingID));
        if(initialValue.sbsDistricts && 
          initialValue.sbsDistricts.length>0){
            let activatedBuildings =[];
            getValues('sbsDistrict').forEach((record)=>{
              const buildingsData = record.buildings;
              let buildingIds = Object.keys(buildingsData).filter(
                (e) => buildingsData[e].sbsEnabled === true
              );
              activatedBuildings.push(...buildingIds)
             
        
          });
           setBuildings(activatedBuildings);
        }
      }else if(getValues('sbsDistrict').length>0){
            let activatedBuildings =[];
            getValues('sbsDistrict').forEach((record)=>{
              const buildingsData = record.buildings;
              let buildingIds = Object.keys(buildingsData).filter(
                (e) => buildingsData[e].sbsEnabled === true
              );
              activatedBuildings.push(...buildingIds)
          });
           setBuildings(activatedBuildings);
      }else{
        setValue("sbsBuilding", []);
      }
      setValue("sbsRole", initialValue.role);
      setIsActiveTicked(initialValue?.isActive);
      setSbsDistrict(initialValue?.sbsDistricts);
      setSbsBuilding(initialValue?.sbsBuildings)
      setSbsRole(initialValue?.role);
    }
  }, [initialValue, districts]);

  useEffect(() => {
    selectedWorker
      ? getLocationForCountry(
          //selectedWorker.worker?.countryCode,
          //selectedWorker.worker?.alternateCountryCode
        )
          .then((data) => {
            let districtBuildingObj={};
            data.forEach((record)=>{
              let DistSbsEnabled = false;
              let buildingIdMap ={};
              Object.entries(record.buildings).map((buildingDet)=>{
                if(buildingDet[1].sbsEnabled ===true){
                  DistSbsEnabled =true;
                  buildingIdMap[buildingDet[0]]={
                    buildingID:buildingDet[0],
                    districtID:record.district,
                    oracleID:buildingDet[1].oracleId?buildingDet[1].oracleId:''
                  };
                }
              });
              if(buildingIdMap && Object.keys(buildingIdMap).length>0){
                districtBuildingObj[record.district] =buildingIdMap; 
              }
              record.DistSbsEnabled = DistSbsEnabled;
            });
           const  filteredDistricts = data.filter((record)=> record.DistSbsEnabled === true);
             setSbsDistBuilingMap(districtBuildingObj);
              setDistricts([...filteredDistricts]);
            
          })
          .catch((err) => {
            console.log("Get districts in SBS User access ", err);
          })
      : getLocationForCountry(
         // manager?.countryCode,
         // manager?.alternateCountryCode
        )
          .then((data) => {
            let districtBuildingObj={};
            data.forEach((record)=>{
              let DistSbsEnabled = false;
              let buildingIdMap ={};
              Object.entries(record.buildings).map((buildingDet)=>{
                
                if(buildingDet[1].sbsEnabled === true){
                  DistSbsEnabled = true;
                  buildingIdMap[buildingDet[0]]={
                    buildingID:buildingDet[0],
                    districtID:record.district,
                    oracleID:buildingDet[1].oracleId?buildingDet[1].oracleId:''
                  };
                }
              });
              if(buildingIdMap && Object.keys(buildingIdMap).length>0){
                districtBuildingObj[record.district] =buildingIdMap; 
              }
              
              record.DistSbsEnabled = DistSbsEnabled;
            });
           const  filteredDistricts = data.filter((record)=> record.DistSbsEnabled === true);
            setSbsDistBuilingMap(districtBuildingObj);
            setDistricts([...filteredDistricts]);
          })
          .catch((err) => {
            console.log("Get districts in SBS User access ", err);
          });
  }, []);
  
  useEffect(() => {
    if (getValues("isSbsActive") || initialValue?.isActive) {
        setIsSbsWorker(true);
    } else {
        setIsSbsWorker(false);
    }
  }, [isActiveTicked]);

  useEffect(() => {
    
    if (getValues("sbsDistrict")?.length === 0 && buildings.length>0){
        setBuildings([]);
    }
    if (getValues("isSbsActive")) {
      if (getValues("sbsDistrict")?.length === 0 ||
        getValues("sbsBuilding")?.length===0 ||
        getValues("sbsRole")?.length === 0 ||
        getValues("sbsRole") === null) {
        setSbsValid(false);
      } else setSbsValid(true);
    } else {
        setSbsValid(true);
    }
  }, [
    getValues("sbsDistrict"),
    getValues("sbsBuilding"),
    getValues("isSbsActive"),
    getValues("sbsRole"),
  ]);

  return (
    <>
    <Typography
        variant="h6"
        gutterBottom
        className={`${classes.employeeId} ${classes.title}`}
      >
        {t("other.lblSbsUserAccess")}
    </Typography>
    <FormControlLabel
      control={
        <Controller
          name="isSbsActive"
          control={control}
          defaultValue={isActiveTicked}
          render={(props) => (
            <>
              <Checkbox
                {...props}
                checked={props.value}
                onChange={(e) => {
                  setIsActiveTicked(e.target.checked);
                  props.onChange(e.target.checked);
                }}
                color="primary"
                style={{ paddingLeft: 0 }}
                inputRef={props.ref}
              />
            </>
          )}
        />
      }
      label={t("other.lblEnableSbsAccess")}
    />
   <Controller
        name="sbsDistrict"
        control={control}
        defaultValue={sbsDistrict}
        disabled={!isActiveTicked}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={districts}
            value={props.value}
            disableClearable
            disableCloseOnSelect
            clearOnBlur
             getOptionLabel={(option) => option.district?option.district:option}
            disabled={!isActiveTicked}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="sbsDistrict"
                name="sbsDistrict"
                label={properCase( props.value.length > 0 ? t( "other.lblDistrict") : t( "general.select1" ))}
                required={getValues("isSbsActive")}
                error={
                  Boolean(errors.sbsDistrict)
                }
                 
              />
            )}
            onChange={(e, newValue) => {
                props.onChange(newValue);
                if(!newValue|| newValue.length<=0){
                  setValue('sbsBuilding', []);
                }
                let activatedBuildings =[];
                  newValue.forEach((record)=>{
                    const buildingsData = record.buildings;
                    let buildingIds = Object.keys(buildingsData).filter(
                      (e) => buildingsData[e].sbsEnabled === true
                    );
                    activatedBuildings.push(...buildingIds)
                  });
                  if(getValues('sbsBuilding').length>0){
                    const filteredbuildingIds = getValues('sbsBuilding').filter((buildingId)=>{
                      return activatedBuildings.includes(buildingId)
                    });
                    setValue('sbsBuilding', filteredbuildingIds);
                  }
                
                setBuildings(activatedBuildings);
                 
            }}
          />
        )}
      />
    <Controller
        name="sbsBuilding"
        control={control}
        defaultValue={sbsBuilding}
        disabled={!isActiveTicked}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={buildings}
            value={props.value}
            disableClearable
            disableCloseOnSelect
            disabled={!isActiveTicked}
            getOptionLabel={(option) => option?.buildingID?option.buildingID:option}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="sbsBuilding"
                name="sbsBuilding"
                label={properCase( props.value.length > 0 ? t( "other.lblBuilding") : t( "general.select2" ))}
                required={getValues("isSbsActive")}
                error={
                  Boolean(errors.sbsBuilding)
                }
                
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />


    <Controller
        name="sbsRole"
        control={control}
        defaultValue={sbsRole}
        disabled={!isActiveTicked}
        rules={isActiveTicked ? { required: "Role cannot be blank" } : false}
        render={(props) => (
          <Autocomplete
            size="small"
            style={{ marginTop: 20, marginBottom: 20 }}
            options={["Team Leader", "Supervisor", "Super User", "Warehouse Ops"]}
            value={props.value}
            disableClearable
            disabled={!isActiveTicked}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="sbsRole"
                name="sbsRole"
                label={properCase( props.value ? t( "other.lblRole") : t( "other.lblSelectRole" ))}
                required={getValues("isSbsActive")}
                error={Boolean(errors.sbsRole) && isActiveTicked}
                helperText={errors.sbsRole?.message}
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />
    </>
  );
 };
 export default SBSUserAccess;
  